import React, { useState } from 'react';

import { Container } from 'styles';
import * as S from './styles';

const Header = () => {
	const [navOpen, setNavOpen] = useState(false);

	return (
		<S.HeaderWrapper>
			<Container>
				<S.HeaderContent>
					<S.Logo to={'/'} />

					<S.NavToggler onClick={() => setNavOpen(old => !old)}>
						<S.NavTogglerIcon className={navOpen && 'isOpen'} />
					</S.NavToggler>

					<S.Nav className={navOpen && 'isOpen'}>
						<S.SectionLinkList>
							<S.SectionLinkItem>
								<S.SectionLink href={`${process.env.REACT_APP_PORTAL_URL}`}>Voltar para o portal</S.SectionLink>
							</S.SectionLinkItem>

							<S.SectionLinkItem>
								<S.SectionLink href={`${process.env.REACT_APP_PORTAL_URL}/cadastrar`}>Cadastre-se</S.SectionLink>
							</S.SectionLinkItem>

							<S.SectionLinkItem>
								<S.SectionLinkButton href={`${process.env.REACT_APP_PRODUCER_URL}/evento/novo`}>Crie seu evento</S.SectionLinkButton>
							</S.SectionLinkItem>
						</S.SectionLinkList>
					</S.Nav>
				</S.HeaderContent>
			</Container>
		</S.HeaderWrapper>
	);
}

export default Header;